import React from "react";
import DayCell from "./DayCell";

export default function CalendarGrid({
  calendar = [],
  onDayClick,
  expandedDay,
  onMoreClick,
  onShowLessClick,
  openEventDetails,
}) {
  const weekdayLabels = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return (
    <div>
      {/* <div className="grid grid-cols-7 gap-1 mb-2">
        {weekdayLabels.map((label, idx) => (
          <div
            key={idx}
            className="text-xs font-semibold text-gray-600 text-center py-1"
            aria-hidden={label === ""}
          >
            {label}
          </div>
        ))}
      </div> */}

      <div className="grid grid-cols-7 gap-1">
        {calendar.map((day) => (
          <DayCell
            key={day.date}
            day={day}
            isExpanded={expandedDay === day.date}
            onClick={() => onDayClick(day)}
            onMoreClick={onMoreClick}
            onShowLessClick={onShowLessClick}
            openEventDetails={openEventDetails}
          />
        ))}
      </div>
    </div>
  );
}
